var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sp-input"},[_c('span',{staticClass:"prefix"},[_vm._v(_vm._s(_vm.prefix))]),_c('el-input',{style:(_vm.styleName),attrs:{"type":"text"},on:{"change":_vm.onChangeInput},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}}),_c('span',{staticClass:"suffix"},[_vm._v(_vm._s(_vm.suffix))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }